import React from 'react';
import { Button } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
}

const UnpublishConfirmButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('components');

  return (
    <Button
      hierarchy="primary"
      tone="danger"
      size="md"
      onClick={onClick}
      data-cy="unpublish-confirm-modal-confirm-btn"
    >
      {t('unpublishRouteConfirmModal.button.text')}
    </Button>
  );
};

export default UnpublishConfirmButton;
